import { ICurrentUser } from '../currentuser/currentUser';
import { Analytics } from '@segment/analytics-next';
import { AnalyticsEvent } from './AnalyticsEvent';
import { mobileConfig } from '../commons/config';
import { isSmallerThanTablet } from '../responsive/hooks/hooks';

export const getStandardCustomProperties = () => {
  const config = mobileConfig();
  return {
    isMobileApp: config.isMobile,
    growegyPlatform: config.growegyMobilePlatform
      ? config.growegyMobilePlatform
      : isSmallerThanTablet()
      ? 'mobile-web'
      : 'web',
  };
};

export const analyticsIdentifyUser = (
  analytics: Analytics | undefined,
  currentUser: ICurrentUser
) => {
  try {
    analytics?.identify(currentUser.userId, {
      roles: currentUser.roles.map((x) => x.id).join(','),
      ...getStandardCustomProperties(),
    });
    analyticsTrack(analytics, AnalyticsEvent.USER_SIGNED_IN);
  } catch (err) {
    logger.error('Error while identifying user: ', err);
  }
};

export const analyticsTrack = (
  analytics: Analytics | undefined,
  analyticsEvent: AnalyticsEvent,
  properties: object = {}
) => {
  try {
    analytics?.track(`${analyticsEvent.entity} ${analyticsEvent.action}`, {
      ...properties,
      ...getStandardCustomProperties(),
    });
  } catch (err) {
    logger.error('Error while reporting analytics event: ', err);
  }
};
